import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-generate-summary-report",
  templateUrl: "./generate-summary-report.component.html",
  styleUrls: ["./generate-summary-report.component.scss"],
})
export class GenerateSummaryReportComponent implements OnInit {
  fromRegId: any = "";
  toRegId: any = "";

  constructor() {}

  ngOnInit() {}

  getReportDetails() {
    alert("fvghb");
  }

  numberOnly(event: any) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
}
